<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <filter-by-status-header
            ref="headerFilter"
            :filterStatus="filterStatus"
            :filterOptions="filterOptions"
            :title="'Văn bản đi (Vai trò đã bị khóa)'"
            @filterByStatus="filterByStatus"
          />
        </template>
      </headerTemplate>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <selector
                  @searchDocCV="searchDocCV"
                  @searchDocVT="searchDocVT"
                />
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div
                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large"
                    >
                      <span class="label-input width__auto"
                        >Ngày văn bản:
                      </span>
                      <el-date-picker
                        v-model="docDateRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="center"
                        :clearable="false"
                        @change="filterByDocDateRange"
                      >
                      </el-date-picker>
                    </div>
                    <div class="margin-right-10 txt-center fix-width__small">
                      <multiselect
                        :class="['style-fullWidth']"
                        :options="docReadStatusFilters"
                        label="name"
                        track-by="id"
                        v-model="docReadStatusFilter"
                        :preselect-first="true"
                        placeholder="-"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :searchable="true"
                        open-direction="bottom"
                        @input="filterByDocReadStatus"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <div
                            class="status-doc flex-row flex__left font-size__medium"
                          >
                            &nbsp;&nbsp;
                            <filterIconByIsRead :isRead="option.id" />
                            <span>{{ option.name }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </template>
                  <template #advance>
                    <banhanh-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      :isEnableSearchTdhvpDoc="true"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                      @searchTdhvpDoc="searchTdhvpDoc"
                      @searchLockedRoleDocOut="searchLockedRoleDocOut"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    STT
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'" />
                  </div>
                </div>
                <div class="rightSection flex-row flex__right">
                  <div
                    class="theTitle theTitle__lv2 flex-row flex__left clickable"
                    @click="doSort('publisherName')"
                  >
                    Đơn vị ban hành
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'publisherName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left"
                    @click="doSort('signerName')"
                  >
                    Người ký duyệt
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'signerName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in outgoingDocs"
                    v-bind:key="$itemIndex"
                    :class="[
                      'item flex-row flex__between clickable',
                      !item.isSeen ? 'is-seen' : ''
                    ]"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                              $itemIndex + 1
                            }}</span>
                          </div>
                          <i
                            class="fas fa-file color__smoke"
                            @click.stop="
                              downloadAttachment(
                                item,
                                ATTACHMENT_OBJECT_TYPE.VB_DI
                              )
                            "
                          ></i>
                        </div>
                      </div>
                      <div class="theTitle__lv1 margin-right-10">
                        <div class="title-docs flex-col flex__left">
                          <div
                            class="tt_1 clickable"
                            v-bind:class="textBold(item)"
                          >
                            <break-word-span
                              :text="item.quote"
                              :maxLength="150"
                            ></break-word-span>
                          </div>
                          <div class="tt_2 flex-row flex__left margin-top-10">
                            <span v-if="item.docCode"
                              >{{ item.docCode }}&nbsp;&nbsp;</span
                            >
                            <el-tag
                              v-if="item.docTypeName"
                              size="mini"
                              :class="['priority', 'lv3']"
                              >{{ item.docTypeName }}
                            </el-tag>

                            <el-tag
                              v-if="isShowPiority(item.priorityId)"
                              size="mini"
                              :class="[
                                'priority',
                                getPiorityClass(item.priorityId)
                              ]"
                            >
                              <i class="fas fa-bolt"></i>
                              <span>
                                {{ item.priorityName }}
                              </span>
                            </el-tag>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv2 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <i class="cellIcon color__silver fas fa-signing"></i>
                          {{ item.publisherName }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <i class="cellIcon color__silver fas fa-signing"></i>
                          {{ item.signerName }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <i class="cellIcon color__silver fas fa-clock"></i>
                          {{
                            item.docDate
                              | dateFormatter({
                                nullValue: "-",
                                dateFormat: "DD/MM/YYYY"
                              })
                          }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>

      <createDialog
        :isOpen="isOpenDialogCreate"
        v-if="isEnableDialogCreate"
        @closed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
      />

      <CCDocOut
        :isOpen="isOpenDocOutCCDialog"
        :docId="selectedDoc.vbOutgoingDocUserViewKey.id"
        :docTitle="selectedDoc.quote"
        @closeDialog="isOpenDocOutCCDialog = false"
        @closed="isEnableDocOutCCDialog = false"
        v-if="isEnableDocOutCCDialog"
        @success="ccSuccess"
      />
    </template>
  </listTemplate>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import dateFormatter from "../../../filters/dateFormatter";
import utils from "../../../services/utils";
import BreakWordSpan from "../../adminstration/ketluan/break-word-span";
import listTemplate from "../../common/list";
import headerTemplate from "../../../components/header/main-header.vue";
import searchTemplate from "../../common/search";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vbOutgoingDocUserViewService from "../../../services/vbOutgoingDocUserViewService";
import constants from "../../../constants";
import { EventBus } from "../../../event-bus.js";
import dateUtils from "../../../dateUtils";
import CCDocOut from "../components/CCDocOut";
import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
import buildAttachmentURL from "../../../filters/buildAttachmentURL";
import FilterByStatusHeader from "../components/filter-by-status-header";
import BanhanhAdvanceSearchDialog from "../components/banhanh-advance-search-dialog";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import h from "../../../services/h";
import Selector from "../../common/locked-role-select-branch.vue";

export default {
  components: {
    Selector,
    BreakWordSpan,
    BanhanhAdvanceSearchDialog,
    FilterByStatusHeader,
    InfiniteLoading,
    listTemplate,
    headerTemplate,
    searchTemplate,
    VuePerfectScrollbar,
    subHeader: () => import("../../../components/main/sub-header.vue"),
    createDialog: () => import("../components/CreateDialog.vue"),
    advanceSearchDialog: () =>
      import("../components/daBanHanhAdvanceSearchDialog.vue"),
    mainContent: () => import("../mainContent.vue"),
    Multiselect: () => import("vue-multiselect"),
    SortCaret: () => import("../SortCaret"),
    CCDocOut,
    filterIconByIsRead: () => import("../../common/filterIconIsReadVban.vue")
  },

  mixins: [vbAttachmentTokenMixin],

  filters: { dateFormatter, buildAttachmentURL },

  data() {
    return {
      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      ROLE: constants.ROLE,
      selectedDoc: null,
      isOpenDocOutCCDialog: false,
      isEnableDocOutCCDialog: false,

      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
      filterOptions: null,

      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      perfectScrollbarSetting: { maxScrollbarLength: 350 },
      outgoingDocs: [],
      page: 0,
      size: 10,
      advanceSearchForm: {},
      sort: null,
      order: null,
      keyword: null,
      docDateRange: [null, null],
      filterStatus: null,
      docReadStatusFilter: null,
      userDeptRole: null,
      docReadStatusFilters: [
        {
          id: null,
          name: "Tất cả"
        },
        {
          id: constants.READ_STATUS.UN_READ,
          name: "Chưa đọc"
        },
        {
          id: constants.READ_STATUS.READED,
          name: "Đã đọc"
        }
      ]
    };
  },

  computed: {
    currentRoute() {
      return this.$route.path.split("/")[3];
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  mounted() {
    EventBus.$on(this.currentRoute, options => {
      this.doSearch();
    });
  },

  watch: {
    isOpenDialogCreate: function(newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },
    isOpenAdvanceSearchDialog: function(newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },
    isOpenDocOutCCDialog(newValue) {
      newValue && (this.isEnableDocOutCCDialog = newValue);
    }
  },

  created() {
    this.initQuery();
    this.loadUserDeptRole().then(() => this.initFilterOptions());
  },

  methods: {
    searchTdhvpDoc() {
      this.$router.push({
        name: "tdhvpDocOutIndex",
        params: this.$route.params
      });
    },

    searchLockedRoleDocOut() {
      this.$router.push({
        name: "lockedRoleDocOutIndex",
        params: this.params
      });
    },

    searchDocCV() {
      this.$router.replace({
        name: "lockedRoleDocOutCV",
        //params: this.$route.params,
        //query: this.buildQuery()
      });
      this.refreshSearch();
    },

    searchDocVT() {
      this.$router.replace({
        name: "lockedRoleDocOutVT",
        //params: this.$route.params,
        //query: this.buildQuery()
      });
      this.refreshSearch();
    },

    filterByDocReadStatus(event) {
      this.advanceSearchForm.isRead = event.id === null ? undefined : event.id;
      this.doSearch();
    },

    CCvanBan(item) {
      this.selectedDoc = item;
      //console.log(this.selectedDoc)
      this.isOpenDocOutCCDialog = true;
    },

    ccSuccess() {
      this.isOpenDocOutCCDialog = false;
    },

    filterByDocDateRange() {
      this.advanceSearchForm.fromDocDate =
        this.docDateRange && this.docDateRange[0]
          ? this.docDateRange[0].getTime()
          : undefined;
      this.advanceSearchForm.toDocDate =
        this.docDateRange && this.docDateRange[1]
          ? this.docDateRange[1].getTime()
          : undefined;
      this.doSearch();
    },

    initQuery() {
      this.sort = this.$route.query.sort || "docDate";
      this.order = this.$route.query.order || "desc";
      this.advanceSearchForm = {
        keyword: this.$route.query.keyword || undefined,
        filterStatus:
          this.$route.query.filterStatus || constants.DU_THAO_PAGE.FILTER.ALL,

        fromDocDate: this.$route.query.fromDocDate
          ? parseInt(this.$route.query.fromDocDate)
          : undefined,
        toDocDate: this.$route.query.toDocDate
          ? parseInt(this.$route.query.toDocDate)
          : undefined,

        fileContent: this.$route.query.fileContent || undefined,
        docTypeId: this.$route.query.docTypeId || undefined,
        priorityId: this.$route.query.priorityId || undefined,
        quote: this.$route.query.quote || undefined,
        otherReceivePlaces: this.$route.query.otherReceivePlaces || undefined,
        receiveDeptId: this.$route.query.receiveDeptId || undefined,
        publisherId: this.$route.query.publisherId || undefined,
        isRead: this.$route.query.isRead
          ? parseInt(this.$route.query.isRead)
          : undefined
      };

      this.docReadStatusFilter = h.find(
        this.docReadStatusFilters,
        item =>
          item.id ===
          (this.advanceSearchForm.isRead === undefined
            ? null
            : this.advanceSearchForm.isRead)
      );
      this.filterStatus = this.advanceSearchForm.filterStatus;
      this.keyword = this.advanceSearchForm.keyword;
      this.initDocDateRange();
    },

    buildQuery() {
      return utils.merge(
        { sort: this.sort || "updateTime", order: this.order || "desc" },
        this.advanceSearchForm
      );
    },

    filterByStatus(event) {
      this.advanceSearchForm.filterStatus = this.filterStatus =
        event.filterStatus;
      this.doSearch();
    },

    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.keyword = keyword;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.fileContent = undefined;
      this.advanceSearchForm.priorityId = undefined;
      this.advanceSearchForm.docTypeId = undefined;
      this.advanceSearchForm.publisherId = undefined;
      this.advanceSearchForm.receiveDeptId = undefined;
      this.advanceSearchForm.otherReceivePlaces = undefined;
      this.doSearch();
    },

    advanceSearch(event) {
      let advanceSearchForm = event.advanceSearchForm;
      this.advanceSearchForm.keyword = undefined;
      this.keyword = null;
      this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
      this.advanceSearchForm.fileContent =
        advanceSearchForm.fileContent || undefined;
      this.advanceSearchForm.priorityId =
        advanceSearchForm.priorityId || undefined;
      this.advanceSearchForm.docTypeId =
        advanceSearchForm.docTypeId || undefined;
      this.advanceSearchForm.publisherId =
        advanceSearchForm.publisherId || undefined;
      this.advanceSearchForm.receiveDeptId =
        advanceSearchForm.receiveDeptId || undefined;
      this.advanceSearchForm.otherReceivePlaces =
        advanceSearchForm.otherReceivePlaces || undefined;
      this.advanceSearchForm.fromDocDate =
        advanceSearchForm.fromDocDate || undefined;
      this.advanceSearchForm.toDocDate =
        advanceSearchForm.toDocDate || undefined;
      this.initDocDateRange();
      this.doSearch();
    },

    initDocDateRange() {
      if (
        this.advanceSearchForm.fromDocDate ||
        this.advanceSearchForm.toDocDate
      ) {
        this.docDateRange = [
          dateUtils.toMoment(this.advanceSearchForm.fromDocDate),
          dateUtils.toMoment(this.advanceSearchForm.toDocDate)
        ];
      } else {
        this.docDateRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
        this.advanceSearchForm.fromDocDate = defaultTimeRange[0];
        this.advanceSearchForm.toDocDate = defaultTimeRange[1];
      }
    },

    doSort(sort) {
      this.sort = sort;
      this.order =
        sort == this.sort ? (this.order == "asc" ? "desc" : "asc") : "asc";
      this.doSearch();
    },

    doSearch() {
      this.$router.replace({
        name: "lockedRoleDocOutCV",
        params: this.$route.params,
        query: this.buildQuery()
      });
      this.refreshSearch();
    },

    refreshSearch() {
      this.outgoingDocs = [];
      console.log("this.outgoingDocs");
      console.log(this.outgoingDocs);
      this.page = 0;
      this.$nextTick(
        () =>
          this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset()
      );
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    async list() {
      const lockedUserDeptRole = this.$store.getters.lockedUserDeptRole
        .userDeptRoleId;
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(",")
      };
      let docStatus = [constants.OUTGOING_DOC_STATUS.DABANHANH];

      let relationType;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_UY_QUYEN;
          break;
        case constants.DU_THAO_PAGE.FILTER.CC:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_CC;
          break;
        default:
          relationType = null;
          break;
      }

      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        docStatus: docStatus,
        relationType: relationType,
        status: status
      });

      let items = [];

      await vbOutgoingDocUserViewService
        .findbyLockedRoleCV(advanceSearchForm, pageable, lockedUserDeptRole)
        .then(response => {
          items = response.data;
          items && this.outgoingDocs.push(...items);
        });
        return items;
    },

    viewDetail(item) {
      item.isSeen = 1;
      let query = utils.merge(this.$route.query, {
        vbDocProcessId: item.vbDocUserVbDocProcessId
      });
      this.$router.push({
        name: "DetailLockedRoleDocOut",
        params: {
          userDeptRoleId: this.userDeptRoleId,
          id: item.vbOutgoingDocUserViewKey.id
        },
        query: query
      });
    },

    initFilterOptions() {
      this.filterOptions = [];

      this.filterOptions.push({
        value: constants.DU_THAO_PAGE.FILTER.ALL,
        label: "Tất cả",
        iconClass: null
      });

      if (this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO)
        this.filterOptions.push({
          value: constants.DU_THAO_PAGE.FILTER.UY_QUYEN,
          label: "Ủy quyền",
          iconClass: null
        });

      this.filterOptions.push({
        value: constants.DU_THAO_PAGE.FILTER.CC,
        label: "CC",
        iconClass: null
      });
    },

    /**
     * neu la quyen lanh dao thi moi them tab uy quyen;
     */
    loadUserDeptRole() {
      return userDeptRoleViewService
        .findById(this.userDeptRoleId)
        .then(response => {
          this.userDeptRole = response.data;
        });
    },

    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    isShowPiority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    },

    isSeen(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen == 1) return "";
        else return "is-seen";
      } else return "";
    },

    textBold(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen == 1) return "";
        else return "text-bold";
      } else return "";
    }
  }
};
</script>

<style scoped>
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}

.text-bold {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/locked-role/lockedRoleDocOutCV.vue